<template>
  <v-container fluid>
    <a name='schedule'></a>
    <h2><a href='#schedule'>Schedule</a></h2>
    <v-container grid-list-md>
      <!--
      <v-container class='reception' :v-style='{marginTop: "2rem"}' fluid>
        coming soon
      </v-container>
      -->

      <v-container class='reception' fluid>
        11月3日 13:30 開場
      </v-container>

      <v-layout v-for='section in timeline' :key='section.time' class='section' d-flex>
        <v-container class='section_time'>
          <h3>{{ section.time }}</h3>
        </v-container>

        <v-container v-if='section.contents' class='section_contents'>
          <v-container class='section_contents_overview'>{{ section.contents.overview }}</v-container>

          <v-container d-flex justify-space-between v-if='section.contents.name' class='section_contents_attach font_caption'>
            <v-container class='section_contents_attach_name'>
              <span class='section_contents_attach_name_text' v-bind:class='[ section.contents.type ]'>
                {{ section.contents.name }}
              </span>
            </v-container>
            <v-container class='section_contents_attach_guests'>
              <div v-for='account of section.contents.guests' :key='account.id'>
                <a :href='`#speaker_${account.id}`'>{{ account.name }}</a>
              </div>
            </v-container>
          </v-container>
        </v-container>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'eventtimeline',
  props: {},
  data: () => {
    return {
      timeline: [
        {
          time: '14:00',
          contents: {
            overview: 'イベント開始・挨拶'
          }
        },
        {
          time: '14:05',
          contents: {
            guests: [
              {
                id: 'tomoki',
                name: 'TOMOKI++'
              }
            ],
            name: '15分間セッション',
            overview: 'ボカロ丼の立ち上げ経緯や運営、ボーカロイドコミュニティ内のボカロ丼の位置について',
            type: 'session'
          }
        },
        {
          time: '14:25',
          contents: {
            guests: [
              {
                id: 'toneji',
                name: 'とねぢ@箕面どん'
              }
            ],
            name: '5分間LT',
            overview: '箕面どんのこれまで、今、これから',
            type: 'lt'
          }
        },
        {
          time: '14:35',
          contents: {
            guests: [
              {
                id: 'guskma',
                name: 'ぐすくま'
              }
            ],
            name: '5分間LT',
            overview: '鯖缶工場について',
            type: 'lt'
          }
        },
        {
          time: '14:45',
          contents: {
            overview: '休憩'
          }
        },
        {
          time: '15:00',
          contents: {
            guests: [
              {
                id: 'localadms',
                name: 'ろーかるゆーざー'
              }
            ],
            name: '15分間セッション',
            overview: '私や当インスタンスの紹介を通じて、コレまでどの様な技術を習得してきたか',
            type: 'session'
          }
        },
        {
          time: '15:20',
          contents: {
            guests: [
              {
                id: 'vaginaplant',
                name: 'HakabaHitoyo'
              }
            ],
            name: '5分間LT',
            overview: 'レコメンデーション・フェアネス概論',
            type: 'lt'
          }
        },
        {
          time: '15:30',
          contents: {
            name: 'パネルディスカッション',
            overview: 'マストドンに追加すべきだと思う機能\n新しいつながりを作るために大事だと思うこと',
            type: 'discussion'
          }
        },
        {
          time: '16:10',
          contents: {
            overview: 'イベント終了'
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
  .reception {
    background-color: rgb(234, 234, 234);
    text-align: center;
    padding: 1rem;
  }

  .section {
    border-bottom: solid 1px rgb(213, 213, 213);
  }

  .section:not(first-of-type) {
    margin-top: 5px !important;
  }

  .section_time {
    width: 5rem;
    flex: none !important;
    padding: 0px;
    text-align: center;
  }

  .section_contents {
    border-left: solid 2px rgb(213, 213, 213);
  }

  .section_contents_overview,
  .section_contents_attach,
  .section_contents_attach_name {
    padding: 0px;
  }

  .section_contents_overview {
    white-space: pre-line;
  }

  .section_contents_attach {
    margin-top: 1rem;
  }

  .section_contents_attach_name_text {
    padding: 0.3rem 1rem;
    border-radius: 12.5% / 50%;
    color: white;
    display: inline-block;
    width: 9rem;
    text-align: center;
  }
  .section_contents_attach_name_text.lt {
    background-color: rgb(73, 166, 76);
  }
  .section_contents_attach_name_text.session {
    background-color: rgb(166, 76, 216);
  }
  .section_contents_attach_name_text.discussion {
    background-color: rgb(222, 0, 27);
  }

  .section_contents_attach_guests {
    padding: 0px;
    width: auto;
    flex: none !important;
  }
</style>
